/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Stats_Tab_StatsInputs */

const vi_lot_stats_tab_stats = /** @type {(inputs: Lot_Stats_Tab_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê`)
};

/**

* @param {Lot_Stats_Tab_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_stats_tab_stats = /** @type {((inputs?: Lot_Stats_Tab_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Stats_Tab_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_stats_tab_stats(inputs)
});